import cn from 'classnames';
import React from 'react';

import { Message as Props, types } from './message.types';
import Text from '../text/text';
import Link from '../link/link';
import CloseIcon from '../icons/18/close';
import ConfirmIcon from '../icons/18/confirm';
import ErrorIcon from '../icons/18/error';
import InfoIcon from '../icons/18/info';
import WarningSignIcon from '../icons/18/warning-sign';
import { ValueOf } from 'type-fest';

const icon = (type: ValueOf<typeof Message.types>) => {
  switch (type) {
    case Message.types.error:
      return <ErrorIcon />;
    case Message.types.success:
      return <ConfirmIcon />;
    case Message.types.warning:
      return <WarningSignIcon />;
    case Message.types.info:
    case Message.types.neutral:
    default:
      return <InfoIcon />;
  }
};

const Message: React.FunctionComponent<React.PropsWithChildren<Props>> & {
  types: typeof types;
} = ({
  debugInfo,
  closeLabel,
  children,
  header,
  link,
  showClose,
  showIcon,
  text,
  type = Message.types.info,
  onClose,
}) => (
  <div className={cn('message', { [`message--${type}`]: type })}>
    {showIcon ? <div className="message__icon">{icon(type)}</div> : null}
    <div className="message__sections">
      <div className="message__section">
        {header ? (
          <Text
            theme={Text.themes.emphasis}
            className={cn('message__header', {
              [`message__header--${type}`]: type,
            })}
          >
            {header}
          </Text>
        ) : null}
        <div className="message__inner">
          {children}
          <Text>{text}</Text>
        </div>
        {link ? (
          <div className="message__link">
            <Link {...link} />
          </div>
        ) : null}
      </div>
      {debugInfo ? (
        <div className="message__section message__debug">
          <Text>{debugInfo}</Text>
        </div>
      ) : null}
    </div>
    {showClose ? (
      <div className="message__close">
        {
          <button
            aria-label={closeLabel}
            type="button"
            className="message__close__button"
            onClick={onClose}
          >
            <CloseIcon />
          </button>
        }
      </div>
    ) : null}
  </div>
);

Message.types = types;

export default Message;
